import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of as ObservableOf } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ApiRequest, NotificationService, ErrorMessageParser } from '@xpo-ltl/data-api';
import { User } from '@xpo-ltl/sdk-common';
import { UserApiService } from '@xpo-ltl/sdk-user';
import { CustomerRuleService } from '../services/customer-rule/customer-rule.service';

@Injectable()
export class LoggedInUserResolver implements Resolve<User> {
  constructor(
    private userService: UserApiService,
    private customerRuleService: CustomerRuleService,
    private notificationService: NotificationService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {
    if (this.customerRuleService.user) {
      return ObservableOf(this.customerRuleService.user);
    }
    return this.userService.getLoggedInUser(ApiRequest.concealedCall).pipe(
      tap((response: User) => {
        if (response) {
          this.customerRuleService.user = response;
        }
      }),
      catchError(error => {
        this.notificationService.showSnackBarMessage(`${ErrorMessageParser.parseMessage(error) || error}.`, {
          durationInMillis: 5000,
          status: 'Error'
        });
        return ObservableOf(undefined);
      })
    );
  }
}
